module.exports = "pegasus_template/assets/email1-header-3.png";